import Vue from 'vue';
import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';

@Component
export default class BaseComponent extends Vue
{
    // Used to check in front-end
    public initialized: boolean = true;

    public loading: boolean = true;
    public error: string = null;

    public delayedLoadingTimeout: any = null;
    public delayedLoadingSpan: number = 250;

    setLoading(): void {
        this.loading = true;
        this.error = '';
    }

    setLoaded(): void {
        this.loading = false;
        this.error = '';
    }

    startDelayedLoading() {
        clearTimeout(this.delayedLoadingTimeout);
        this.delayedLoadingTimeout = setTimeout(() => {
            this.setLoading();
        }, this.delayedLoadingSpan);
    }

    stopDelayedLoading() {
        clearTimeout(this.delayedLoadingTimeout);
        this.setLoaded();
    }

    setError(error: string): void {
        this.error = error;
        this.loading = false;
    }
    clearError(): void {
        this.error = null;
    }

    async mounted() {
        // this.$root.$on('bv::collapse::state', (collapseId: any, isJustShown: any) => {
        //     if (collapseId == 'basic_navigation' || collapseId == "sidebar-navigation" || collapseId == "sidebar-filter") {
        //         if (isJustShown) {
        //             document.body.classList.add('slidein-active');
        //         } else {
        //             document.body.classList.remove('slidein-active');
        //         }
        //     }
        // });
    }
}